/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum DatasetCreator {
    UNKNOWN = 'UNKNOWN',
    USER_WEBAPP = 'USER_WEBAPP',
    USER_PIP = 'USER_PIP',
    USER_PIP_LIGHTLY_MAGIC = 'USER_PIP_LIGHTLY_MAGIC',
    USER_WORKER = 'USER_WORKER'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const DatasetCreatorValidatorShape = [
    'UNKNOWN',
    'USER_WEBAPP',
    'USER_PIP',
    'USER_PIP_LIGHTLY_MAGIC',
    'USER_WORKER'
];
export const DatasetCreatorValidator = yup.mixed().oneOf(DatasetCreatorValidatorShape);
export const DatasetCreatorStringifyShapeProperties = {};
export const DatasetCreatorStringifyShape: StringSchema = {
    title: 'DatasetCreator Stringifier',
    type: 'string'
};
export const DatasetCreatorStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasetCreatorStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function DatasetCreatorFromJSON(json: any): DatasetCreator {
    return DatasetCreatorFromJSONTyped(json, false);
}
export function DatasetCreatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetCreator {
    return json as DatasetCreator;
}
export function DatasetCreatorToJSON(value?: DatasetCreator | null): any {
    return value as any;
}
